import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const OccurrenceDashboardService = {
    apply: async (payload) => axios.post(API_URL + "/occurrence_dashboard/apply", payload).then(({data}) => data.data).catch((error) => { throw error }),
    cityFact: async () => axios.get(API_URL + "/locations/getOccurrencesCityFact").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),
};

export default OccurrenceDashboardService;